export default function Hero() {
  return (
    <section className="px-6 py-20">
      <div className="mx-auto max-w-6xl rounded-[2rem] border border-white/10 bg-white/10 p-8 shadow-2xl shadow-black/20 backdrop-blur md:p-12">
        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.22em] text-cyan-300">
          Planning with discipline
        </p>
        <div className="grid gap-8 md:grid-cols-[1.1fr_0.9fr] md:items-center">
          <div>
            <h2 className="text-3xl font-bold leading-tight md:text-5xl">
              Advanced planning, made understandable.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-slate-200">
              We help families, professionals, and business owners turn moving pieces into a clear plan for protection, liquidity, retirement income, and legacy.
            </p>
          </div>
          <div className="rounded-3xl border border-cyan-300/20 bg-slate-950/50 p-6">
            <p className="text-cyan-200 font-semibold">Core focus</p>
            <ul className="mt-4 space-y-3 text-slate-200">
              <li>• Cash value and liquidity strategies</li>
              <li>• Retirement and income planning</li>
              <li>• Insurance protection design</li>
              <li>• Business owner planning conversations</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
